// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"5236":"dcc9f59b","7577":"dcc9f59b"}[chunkId] + ".chunk.css");